import { SchedulerItem, SchedulerItemProps } from "@progress/kendo-react-scheduler"
import React from "react"

function CustomWeekItem(props:SchedulerItemProps){
    return <React.Fragment>
        <SchedulerItem {...props} style={props.style}/>
    </React.Fragment>
}
export {CustomWeekItem}
